export enum ParticleDensityDeterminationMethod {
  Assumed = 'Assumed',
  Measured = 'Measured',
}

export enum PreparationMethod {
  Moist = 'Moist',
  PreTreated = 'PreTreated',
}

export enum ViscosityOfWaterDetermination {
  Interpolation = 'Interpolation',
  Approximation = 'Approximation',
}

export type IHydrometerReadingProps = {
  Index: number;
  Exclude: boolean;
  CanExclude: boolean;
  CannotSetTemperature: boolean;
};
